import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import { OidcClientOAuth2ServiceImpl } from 'src/features/oauth2/lib/OidcClientOAuth2ServiceImpl';
import { ApiAuthService } from 'src/services/ApiAuthService';
import { WebOAuth2StorageService } from 'src/services/OAuth2StorageService/WebOAuth2StorageService';
import { WebOidcLocationService } from 'src/services/OidcLocationService/WebOidcLocationService';
import { ReauthenticationService } from 'src/services/ReauthenticationService';
import { SessionMonitorService } from 'src/services/SessionMonitorService';
import { WebSyncStorageService } from 'src/services/SyncStorageService/WebSyncStorageService';
import type { IsomorphicBindings } from 'src/types/bindings';

export const webOAuth2Module = new TypedContainerModule<IsomorphicBindings>((bind) => {
    bind('OAuth2StorageService').to(WebOAuth2StorageService).inSingletonScope();
    bind('OidcLocationService').to(WebOidcLocationService).inSingletonScope();
    bind('SyncStorageService').to(WebSyncStorageService).inSingletonScope();
    bind('OAuth2Service').to(OidcClientOAuth2ServiceImpl).inSingletonScope();
    bind('SessionService').toService('OAuth2Service');
    bind('ApiAuthService').to(ApiAuthService).inSingletonScope();
    bind('SessionMonitorService').to(SessionMonitorService).inSingletonScope();
    bind('ReauthenticationService').to(ReauthenticationService).inSingletonScope();
});
